/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { sharedMyAccountDetailsLinesStyles } from "@monsma/App/ComponentExtensions/OrderLinesListExtension";
import { rfqQuoteDetailsRequestedDetailsGridStyles } from "@monsma/Overrides/Widgets/RfqQuoteDetails/RfqQuoteDetailsRequestedDetailsGrid";
import { screen } from "@monsma/XDL/Helpers";
import { css } from "styled-components";

rfqQuoteDetailsRequestedDetailsGridStyles.countLabelText = {
    weight: 600,
};

rfqQuoteDetailsRequestedDetailsGridStyles.footerWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: flex-end;
        margin-top: 20px;
        
        @media print {
            float: right;
        }
    `
};

rfqQuoteDetailsRequestedDetailsGridStyles.countValueText = {
    variant: "h5",
    as: "h2",
    css: css`
        @media print {
            font-size: 15px;
            padding-top: 15px;
            margin-bottom: 5px;
        }
        padding-top: 30px;

        ${screen("lt", "lg")} {
            padding-top: 0;
        }
    `,
};
rfqQuoteDetailsRequestedDetailsGridStyles.productPrice = {};
rfqQuoteDetailsRequestedDetailsGridStyles.quantityHeadingAndText =
    sharedMyAccountDetailsLinesStyles.smallHeadingAndTextContent;

rfqQuoteDetailsRequestedDetailsGridStyles.totalLabelText = {
    ...rfqQuoteDetailsRequestedDetailsGridStyles.totalLabelText,
    size: 18,
};

rfqQuoteDetailsRequestedDetailsGridStyles.totalValueText = {
    ...rfqQuoteDetailsRequestedDetailsGridStyles.totalValueText,
    size: 18,
};

rfqQuoteDetailsRequestedDetailsGridStyles.totalWithoutVatText = {
    ...rfqQuoteDetailsRequestedDetailsGridStyles.totalWithoutVatText,
    size: 18,
};

rfqQuoteDetailsRequestedDetailsGridStyles.totalLabelText = {
    ...rfqQuoteDetailsRequestedDetailsGridStyles.totalLabelText,
    size: 18,
};
